module.exports = __webpack_public_path__ + "static/media/K-empty.6eadb524.svg";